import { usePrivyWalletContext } from 'src/providers/wallets/PrivyWalletProvider';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { abbreviateAddress } from '@drift/common';

interface Params {
	disableAbbreviateAddress?: boolean;
}

export default function useWalletIdentity({
	disableAbbreviateAddress,
}: Params = {}) {
	const { user, sessionMode } = usePrivyWalletContext();
	const walletPubKey = useDriftStore(
		(s) => s.wallet.current?.adapter?.publicKey
	);

	if (sessionMode === 'privy-native' && user) {
		return user.email?.address ?? user.google?.email ?? '';
	}

	if (!walletPubKey || disableAbbreviateAddress) {
		return walletPubKey?.toString() ?? '';
	}

	return abbreviateAddress(walletPubKey);
}
